import { render } from "./FooterCopyright.vue?vue&type=template&id=33c5fc6e&scoped=true"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import "./FooterCopyright.vue?vue&type=style&index=0&id=33c5fc6e&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c5fc6e"]])

export default __exports__